// The frame for the site's small single-purpose pages (2026-09-28): login,
// confirm email, welcome, unsubscribe, not found, errors. A narrow column,
// the shared headline size, one line under it, then whatever the page is for.
export const SIMPLE_LINK =
  'text-foreground underline decoration-foreground/60 decoration-[1.5px] underline-offset-4 transition-colors hover:decoration-foreground'

export default function SimplePage({ title, lede, children }) {
  return (
    <article className="mx-auto w-full max-w-md px-4 py-12 sm:py-16">
      <h1 className="font-serif text-[26px] font-medium leading-tight tracking-tight text-foreground sm:text-[34px]">
        {title}
      </h1>
      {lede && (
        <p className="mt-1.5 font-sans text-[15px] leading-relaxed text-foreground/80 sm:text-base">
          {lede}
        </p>
      )}
      {children}
    </article>
  )
}
